export default __webpack_public_path__ + "static/media/Horne FL 9.9acf31bf.JPEG";